<template>
  <div class="index" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="水木家居" :showBack="false"></my-header>
    <div class="index-top">
      <div class="title">今日推荐</div>
      <div class="swiper-wrapper">
        <mt-swipe :auto="10000" class="banner-weiper" slidesOffsetAfter="1" >
          <mt-swipe-item v-for="(carousel, index) in carouselList" :key="index" @click="goRecommend(carousel)">
            <img :src="imgUrl + carousel.image" class="banner-image"/>
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </div>
    <div class="index-main-two">
      <img src="../assets/index/index-lable-jcsc.png" @click="goShopList()">
      <img src="../assets/index/index-lable-jpgz.png" @click="seekGangmaster()">
    </div>
    <div class="index-main-operation">
      <img src="../assets/index/index-lable-hdzx.png" class="second-line" @click="goActivityList()">
      <img src="../assets/index/index-lable-zxgs.png" class="second-line" @click="goCompanyList()">
      <img src="../assets/index/index-lable-yxjl.png" @click="seekSupervisor()">
      <img src="../assets/index/index-lable-yxsj.png" class="second-line" @click="goDesignerList()">
    </div>
    <div class="Hyperlinks">
      <div class="Hyperlinks-content" v-for="(linkItem,index) in linkData" :key="index" @click="toLinkdetail(linkItem.linkId)">#{{linkItem.name}}</div>
    </div>
    <!-- <div class="index-lesser-operation-part"> -->
      <!-- <div class="title">便捷服务</div>
      <div class="operation-list">
        <img src="../assets/index/puncher-enter.png" @click="toPuncherList()">
        <img src="../assets/index/icon-material-store.png" @click="goStoreList()">
        <img src="../assets/index/icon-article-list-enter.png" @click="toArticleList()">
        <img src="../assets/index/icon-worker-enter.png" @click="preOpenTip()"> -->
        <!--<img src="../assets/index/icon-activity-enter.png" @click="goActivityList()">-->
        <!--<img src="../assets/index/icon-material-store.png" @click="goStoreList()">-->
        <!--<img src="../assets/index/icon-nearbysite-enter.png" @click="toNearbySite()">-->
        <!--<img src="../assets/index/icon-article-list-enter.png" @click="toArticleList()">-->

        <!--<img src="../assets/index/icon-mover-enter.png" class="second-line" @click="toMoverList()">-->
        <!--<img src="../assets/index/icon-cleaner-enter.png" class="second-line" @click="toCleanerList()">-->
        <!--<img src="../assets/index/icon-punch-enter.png" class="second-line" @click="toPuncherList()">-->

      <!-- </div> -->
    <!-- </div> -->
    <div class="recent-news">
      <div class="recent-news-header">近期动态</div>
      <div class="recent-news-box" @click="toNews(recentNews[0])">
        <div><img :src="imgUrl+recentNews[0].cover" alt="" /></div>
        <div class="recent-news-content">
          <div class="recent-news-title">{{ recentNews[0].title }}</div>
          <div class="recent-news-more">更多给您订制</div>
        </div>
      </div>
      <!-- <img src="../assets/index/icon-notice.png"/> -->
      <!-- <div class="notice-list">
        <div class="notice-view" :style="{'margin-top':((adNumber - 2) * -0.76) + 'rem'}" >
          <div class="notice-item" v-for="article in articleList" @click="toArticleDetail(article.id,article.title)">
            <img src="../assets/icon/icon-notice-point.png">{{article.title}}
          </div>
        </div>
      </div> -->
    </div>
    <div class="qa-section" >
      <!-- <div class="qa-top" @click="toQaList()">
        <div class="title">讨论区</div>
        <img src="../assets/index/icon-more-btn.png">
      </div> -->
      <!-- <div v-if="questionList.length>0" class="qa-list">
        <div class="question-item" v-for="question in questionList" @click="toQuestionDetail(question.id)">
          <div class="question-subject">{{question.subject}}</div>
          <div class="question-image-list" v-if="question.imageArray && question.imageArray.length>0">
            <img v-for="img in question.imageArray" :src="imgUrl + img | ossProcess(200, 150)"/>
          </div>
          <div class="question-bottom">
            <div>来自&nbsp;{{question.userName || question.userPhone}}</div>
            <div class="right">
              <div>回答&nbsp;{{question.answerCount || 0}}</div>
              <div class="create-time">{{question.createTime| prettifyTime}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!questionList.length>0" class="black-page" @click="editQuestion">
        <img src="../assets/icon-no-img.png">
        <div class="tip">暂时无人提问，去发布问题</div>
      </div> -->
      <div class="nav-list">
        <div class="title nav-list-item" @click="toRecommend(index)" v-for="(item,index) in navList" :key="index" :class="{navStyle:index==navListIndex}">{{item}}</div>
        <img v-if="navListIndex===0" class="img0" src="../assets/index/db-tab-bg.png">
        <img v-if="navListIndex===1" class="img1" src="../assets/index/db-tab-bg.png">
      </div>
      <div id="waterfallcontent">
        <vueWaterfallEasy v-if="navListIndex===0" :imgsArr="imgsArr" @scrollReachBottom="getData" ref="waterfall" @click="towaterfallArticle">
        <!-- <vueWaterfallEasy :imgsArr="imgsArr" ref="waterfall"> -->
          <div slot-scope="props">
            <div style="margin-left:0.1rem;font-size:0.3rem;margin-top:0.1rem;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{props.value.item.title}}</div>
            <div style="margin-left:0.1rem;" v-if="props.value.item.label">
              <span style="background: #dce7f2;color:#5474c4;margin-right:0.2rem;padding:0.04rem;font-size:0.24rem" v-for="(item,index) in JSON.parse(props.value.item.label)" :key="index">{{item}}</span>
            </div>
            <div style="margin-left:0.1rem;margin-top:0.2rem">
              <img style="border-radius:50%;height:0.55rem;width:0.55rem" :src="props.value.item.authorAvatar" alt="">
              <span style="margin-left:0.1rem;font-size:0.26rem;">{{props.value.item.authorMember.nickname?decodeURI(props.value.item.authorMember.nickname):''}}</span>
            </div>
          </div>
          <div slot="waterfall-over">到底啦</div>
        </vueWaterfallEasy>
        <vueWaterfallEasy v-if="navListIndex===1" :imgsArr="imgsArrBaike" @scrollReachBottom="getDataBaike" ref="waterfallBaike" @click="towaterfallBaike">
          <div slot-scope="props">
            <div :title="props.value.item.title" style="margin-left:0.1rem;font-size:0.3rem;margin-top:0.1rem;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;">{{props.value.item.title}}</div>
          </div>
          <div slot="waterfall-over">到底啦</div>
        </vueWaterfallEasy>
      </div>
    </div>

  </div>
</template>

<script>
  import {imgUrl,shareIcon} from '../config'
  import {Toast, Swipe, SwipeItem } from 'mint-ui'
  import Header from '../components/header/Header'
  import questionService from '../service/qa/QuestionService'
  import CmsArticleService from '../service/article/ArticleService'
  import shareService from '../service/share/ShareService'
  import carouselService from '../service/carousel/CarouselService'
  import userService from '../service/customer/UserService'
  import appRecommendService from '../service/cloud/AppRecommendService'
  import appLinkService from '../service/cloud/AppLinkService'
  import session from '../utils/Session'
  import Tools from "../utils/Tools";
  import axios from "axios";
  import vueWaterfallEasy from 'vue-waterfall-easy'

  export default {
    name: 'Index',
    components: {
      'my-header': Header,
      vueWaterfallEasy
    },
    data () {
      return {
        // 推荐和装修百科
        navList: ['推荐','装修百科'],
        navListIndex:0,
        // 瀑布流数据
        imgsArr: [],
        imgsArrBaike: [],
        // 瀑布流接口页数
        group: 0,
        groupBaike: 0,
        // 近期动态
        recentNews: [{}],
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        carouselList:[],
        questionList:[],
        adNumber:1,
        noticeTimer: null,
        articleList:[],
        subCategoryId:20, //首页轮播文章
        isWechatBrowser:this.$verfyBrowserType(),
        redirectName:'',
        linkData:[],
      }
    },
    created() {
      this.getData();
      this.getDataBaike();
      this.getRecentNews();
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getQuestionList();
      this.getArticleList();
      this.getCarouselList();
      this.initWechatShare();
      this.checkUserLogin();
      this.getGangmasterLinkList();
    },
    methods: {
      // 跳转近期动态详情
      toNews(item) {
        this.$router.push({name: 'ArticleDetail', query: {articleId:item.id,title:item.title}});
      },
      // 近期动态
      async getRecentNews() {
        const token = await session.getToken();
        axios.post("https://xapi.shuimujiaju.com/cms/article/list?subCategoryIdArray=20&pageNo=1",{},{headers:{"authorization":token}}).then(res=>{
          console.log('近期动态', res)
          this.recentNews = res.data.data.result;
        })
      },
      // 点击瀑布流卡片跳转详情
      towaterfallArticle(event,{index,value}) {
        // console.log('瀑布流event', event)
        // console.log('瀑布流index', index)
        // console.log('瀑布流value', value)
        if(value.item.refType === 1){
          this.$router.push({name: 'ArticleDetail', query: {articleId:value.item.refId,title:value.item.title}});
        }
      },
      towaterfallBaike(event,{index,value}) {
        // console.log('瀑布流value', value)
        this.$router.push({name: 'ArticleDetail', query: {articleId:value.item.id,title:value.item.title}});
      },
      // 切换颜色
      toRecommend(index) {
        this.navListIndex = index
      },
      // 瀑布流数据
      async getData() {
        const res = await appRecommendService.page(this.group)
        let arr = []
        console.log('records', res)
        res.data.records.forEach(item=>{
          arr.push({src:item.cover,item})
        })
        this.group++
        if(this.group===2){
          this.$refs.waterfall.waterfallOver()
          return
        }
        this.imgsArr = this.imgsArr.concat(arr)
      },
      async getDataBaike() {
        const token = await session.getToken();
        axios.post("https://xapi.shuimujiaju.com/cms/article/list?subCategoryId=10&pageSize=20&pageNo="+this.groupBaike,{},{headers:{"authorization":token}}).then(res=>{
          // this.imgsArr = this.imgsArr.concat(res.data.data.records.map(item=>{
          //   return item.cover
          // }))
          let arr = []
          res.data.data.result.forEach(item=>{
            arr.push({src:this.imgUrl+item.cover,item})
          })
          this.groupBaike++
          if(this.groupBaike===2){
            this.$refs.waterfallBaike.waterfallOver()
            return
          }
          this.imgsArrBaike = this.imgsArrBaike.concat(arr)
          // console.log('瀑布流百科',this.imgsArrBaike)
        })
      },
      // 获取优选工长超链接
      async getGangmasterLinkList(){
        const result = await appLinkService.list(1)
        this.linkData = result.data
      },
      // 超链接详情
      async toLinkdetail(id){
        const res = await appLinkService.get(id)
        let detailLink = res.data
        if(this.global.isMiniProgrm && detailLink.refTypeValue == 1){
          wx.miniProgram.navigateTo({
            url: `/pages/article/detail/detail?articleId=${detailLink.refId}`,
          })
        }else if(this.global.isMiniProgrm && detailLink.refTypeValue == 2){
          wx.miniProgram.navigateTo({
            url: `/pages/circle/detail/detail?articleId=${detailLink.refId}`,
          })
        }else {
          this.$router.push({name: 'ArticleDetail', query: {articleId:detailLink.refId,title:detailLink.name}});
        }
      },
      async initWechatShare(){
        let title = "水木家居商城";// 分享标题
        let desc = "国内专业的网上建材家居团购平台，为您提供性价比最高的整包套餐及建材团购。"; // 分享描述
        let link = window.location.href; // 分享链接
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async goRecommend(carousel){
        console.info(carousel);
        if(carousel.type == '0'){
          let linkPath = '/' + this.getQueryStringByName(carousel.linkUrl,'add');
          this.$router.push({ path: linkPath })
        }else if(carousel.type == '1'){
          let activityId = this.getQueryStringByName(carousel.linkUrl,'activityId');
          this.$router.push({name: 'ActivityDetail', query: {activityId}})
        }
      },
      getQueryStringByName(url,name){
        let result = url.match(new RegExp("[\?\&]" + name+ "=([^\&]+)","i"));
        return result[1];
      },
      async getCarouselList(){
        let {code,data} = await carouselService.list('INDEX');
        if(code == 0){
          this.carouselList = data;
          for (let carousel of this.carouselList){
            if(carousel.title && carousel.title.length > 9){
              carousel.title = carousel.title.substring(0,9)+'...'
            }
          }
        }else {
          Toast('获取今日推荐信息失败!');
        }
      },
      async getArticleList(){
        let { code, data : {result = []} } = await CmsArticleService.list(this.subCategoryId);
        if(code == 0){
          this.articleList = result;
          this.adNumber = 2;
          if (this.articleList.length > 0) {
            this.noticeTimer = setInterval(() => {
              var adNumber = this.adNumber;
              adNumber += 1;
              if (adNumber > this.articleList.length) {
                adNumber = 2;
              }
              this.adNumber = adNumber;
            }, 5000)
          }
        }else {
          Toast('获取公告信息失败');
        }
      },
      //获取问题列表
      async getQuestionList(){
        let {code,msg,data} = await questionService.list();
        if(code == '0'){
          this.questionList = data.result.slice(0, 3);
          for (let question of this.questionList){
            if(question.images){
              if(question.images.split(',').length>3){
                question.imageArray = question.images.split(',').slice(0, 3);
              }
            }
          }
        }else {
          Toast(msg);
        }
      },
      preOpenTip(){
        Toast('服务暂未开放,敬请期待!')
      },
      toCleanerList(){
        this.$router.push({name: 'CleanerList'})
      },
      toMoverList(){
        this.$router.push({name: 'MoverList'})
      },
      toPuncherList(){
        this.$router.push({name: 'PuncherList'})
      },
      toWorkerList(){
        this.$router.push({name: 'WorkerList'})
      },
      goDesignerList(){
        this.$router.push({name: 'DesignerList'})
      },
      goCompanyList(){
        this.$router.push({name: 'OnestopCompanyList'})
      },
      goStoreList(){
        this.$router.push({name: 'StoreList'})
      },
      goActivityList(){
        this.$router.push({name: 'ActivityList'})
      },
      goShopList(){
        this.$router.push({name: 'ShopList'})
      },
      seekGangmaster(){
        this.$router.push({name:'GangmasterSeek',params:{}});
      },
      seekSupervisor(){
        this.$router.push({name:'SupervisorSeek',params:{}});
      },
      openOnestopSetMeal(){
        this.$router.push({name:'OnestopSetMeal',params:{}});
      },
      toArticleList(){
        this.$router.push({name:'ArticleList',});
      },
      openProductDetail(shopId,productId){
        this.$router.push({name:'ProductDetail',query:{shopId,productId}});
      },
      toQaList(){
        this.$router.push({name:'QaList'});
      },
      //跳转文章详情
      toArticleDetail(id,title){
        this.$router.push({name: 'ArticleDetail', query: {articleId:id,title}})
      },
      editQuestion(){
        this.$router.push({name: 'QaEdit'});
      },
      toQuestionDetail(questionId){
        this.$router.push({name: 'QaDetail',query:{questionId}});
      },
      toNearbySite(){
        this.$router.push({name: 'OnestopNearbySite'});
      },
      checkUserLogin() {
        let { inLight }= Tools.getRequestParam();
        session.setInLight({ inLight: inLight === '1' });
        session.isLogin().then(flag => {
          if(!flag && !!session.getOpenId() && Tools.verfyBrowserType()){
            userService.wechatLogin(session.getOpenId()).then(res => {
              if(res.code == '0'){
                session.accountToken(res.data);
                session.login(res.data);
              }
            });
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .recent-news{
    height: 0.76rem;
    padding: 0.29rem;
    margin-bottom: 1rem;
    img{
      width: 1.8rem;
      padding: 0.2rem;
      border-radius: 0.33rem;
    }
  }
  .recent-news-header{
    margin-right: 0.4rem;
    color: #000000;
    font-size: 0.34rem;
  }
  .recent-news-box{
    background:#f2f2f2;
    height:1.5rem;
    margin-top:0.18rem;
    border-radius:0.1rem;
    display:flex;
  }
  .recent-news-content{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom:0.2rem;
  }
  .recent-news-title{
    font-size: 0.34rem;
    padding-top:0.17rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:1;
    -webkit-box-orient: vertical;
  }
  .recent-news-more{
    font-size: 0.2rem;
    font-weight: bold;
    font-stretch: normal;
    color: #e07070;
  }
  .nav-list{
    width: 6.9rem;
    margin: 0 auto;
    padding-top: 0.3rem;
    padding-bottom: 0.32rem;
    display: flex;
    position: relative;
    .img0{
      position: absolute;
      top: 0.74rem;
      left: -0.1rem;
      width: 0.9rem;
      opacity: 0.8;
    }
    .img1{
      position: absolute;
      top: 0.74rem;
      left: 0.97rem;
      width: 0.9rem;
      opacity: 0.8;
    }
  }
  .nav-list-item{
    margin-right: 0.4rem;
    color: #999999;
    font-size: 0.34rem;
  }
  .navStyle{
    color: #000000;
    font-size: 0.41rem;
  }
  #waterfallcontent{
    position: absolute;    /*必须*/
    top:1rem;              /*top必须，大小可控制*/
    bottom:0;              /*bottom必须，一直延申到当前块底部*/
    width:100%;
  }
  .banner-weiper ::v-deep .mint-swipe-indicators{
    left:80%;
  }
  .banner-weiper ::v-deep .mint-swipe-indicator{
    opacity: 0.7;
  }
  .banner-weiper ::v-deep .mint-swipe-indicator.is-active{
    width:0.23rem;
    border-radius: 40%;
  }
  // 超链接样式
  .Hyperlinks {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-flow: wrap;
    margin: 0.2rem 0;
    padding: 0 0.5rem 0.4rem 0.5rem;
    // box-sizing: border-box;
    font-size: 0.26rem;
    font-weight: 400;
    border-bottom: solid 0.2rem #f2f2f2;
  }
  .Hyperlinks-content{
    padding-top: 0.26rem;
    margin-right: 0.4rem;
  }
  .index-main-two{
    display:flex;
    margin-top:1.3rem;
    justify-content: space-between;
    box-sizing: border-box;
    padding:0 1rem;
    img{
      height: 1rem;
    }
  }
  .clear-header{
    margin-top: -1rem;
  }
  .index{
    font-size: 0.36rem;
    font-weight: 700;
    .index-top{
      height: 3.1rem;
      background: url("../assets/index/icon-top-bg.png") no-repeat;
      background-size: 100%;
      .title{
        padding: 0.3rem 0.3rem 0.19rem;
      }
    }
    .swiper-wrapper {
      // width: 6.9rem;
      height: 3.2rem;
      margin: 0 auto;
      .banner-weiper {
        width: 100%;
        height: 100%;
        .banner-image {
          width: 100%;
          height: 100%;
          // border-radius: 0.1rem;
          box-shadow: 0px 5px 7px 0px
          rgba(0, 0, 0, 0.1);
        }
      }
    }
    .carousel-list{
      padding-left: 0.3rem;
      padding-bottom: 0.1rem;
      display: flex;
      overflow-x: scroll;
      .carousel-item{
        margin-right: 0.27rem;
        background: white;
        border-radius: 0.08rem;
        box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
        img{
          width: 3.32rem;
          height: 3.32rem;
          display: block;
          border-radius: 0.08rem 0.08rem 0 0;
        }
        .carousel-title{
          height: 0.84rem;
          line-height: 0.87rem;
          margin-left:0.24rem;
          font-size: 0.28rem;
          font-weight: inherit;
        }
      }
    }
    .index-main-operation{
      margin-top: 0.3rem;
      padding: 0rem 0.3rem;
      display: flex;
      justify-content: space-between;
      // flex-flow: wrap;
      img{
        height: 1.3rem;
      }
      .second-line{
        margin-top: 0;
      }
    }
    .index-lesser-operation-part{
      padding-bottom: 0.3rem;
      border-bottom: solid 0.1rem #f7f6f5;
      .title{
        padding: 0rem 0.3rem 0.32rem;
      }
      .operation-list{
        display: flex;
        flex-wrap: wrap;
        img{
          width: 1.5rem;
          height: 1.5rem;
          margin-left: 0.28rem;
        }
        img:first-child{
          margin-left: 0.3rem;
        }
        .second-line{
          margin-top: 0.2rem;
        }
      }
    }
    .notice-part{
      // display: flex;
      height: 0.76rem;
      padding: 0.29rem;
      margin-bottom: 1rem;
      // border-bottom: solid 0.1rem #f7f6f5;
      // color: #7f7d7c;
      // font-size: 0.28rem;
      // font-weight: 400;
      img{
        width: 0.75rem;
        height: 0.76rem;
      }
      .notice-list{
        overflow: hidden;
        padding-left: 0.3rem;
        margin-left: 0.3rem;
        border-left: solid 1px #e0dedc;;
      }
      .notice-item{
        display: flex;
        align-items: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        img{
          width: 0.1rem;
          height: 0.1rem;
          margin-right: 0.1rem;
        }
      }
    }
    .qa-section{
      position: relative;
      height: 12rem;
      .qa-top{
        width: 6.9rem;
        margin: 0 auto;
        padding-top: 0.3rem;
        padding-bottom: 0.32rem;
        display: flex;
        justify-content: space-between;
        img{
          width: 0.19rem;
          height: 0.33rem;
        }
      }
      .qa-list{
        width: 6.9rem;
        margin: 0 auto;
        .question-item{
          padding: 0.3rem;
          margin-bottom: 0.3rem;
          border-radius: 0.1rem;
          box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
          .question-subject{
            padding-bottom: 0.2rem;
            font-size: 0.32rem;
            line-height: 0.4rem;
          }
          .question-image-list{
            display: flex;
            margin-bottom: 0.2rem;
            img{
              width: 2.0rem;
              height: 1.5rem;
              margin-left: 0.25rem;
              border-radius: 0.1rem;
            }
            img:first-child{
              margin-left: 0;
            }
          }
          .question-bottom{
            display: flex;
            justify-content: space-between;
            font-size: 0.24rem;
            color: #cecbca;
            font-weight: lighter;
            .right{
              display: flex;
              .create-time{
                margin-left: 0.25rem;
              }
            }
          }
        }
      }
    }
    .black-page{
      height: 100vh;
      text-align: center;
      img{
        width: 1.57rem;
        height: 1.57rem;
        margin-top: 2.32rem;
      }
      .tip{
        margin-top: 0.4rem;
        font-size: 0.32rem;
        color: #7f7d7c;
      }
    }
  }
</style>
